// extracted by mini-css-extract-plugin
export default {"container":"vZ2f3nvboVNgp_X9wX0V","header":"wEOFUiLOfluq86BrDUfg","body":"smUyK5_90KyZt6oX3xNw","footer":"esKZqzTgps1NRn7E3dWA","back":"jvgmNtrZsjvxFBuPr2OQ"};